exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-api-validation-binder {\n  margin-bottom: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/forms/form-api-validation-binder.component.scss
// module id = ../../../../../src/app/shared/forms/form-api-validation-binder.component.scss
// module chunks = main